<div class="header">
  <div>
    <h2>Designation</h2>
    <p>Organize and manage designations to build a better team structure</p>
  </div>
  <button class="add-btn" (click)="toggleModal('add')">
    <img src="assets/images/PlusIcon.svg" alt="" />Add New Designation
  </button>
</div>

<div class="rp-body">
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Title</th>
          <th>Description</th>
          <th class="text-right pr-4">Action</th>
        </tr>
      </thead>
      <tbody *ngIf="loading || showSkeleton">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonCols">
            <div class="skeleton-cell"></div>
          </td>
        </tr>
      </tbody>

      <!-- REAL DATA BODY -->
      <tbody *ngIf="!loading && !showSkeleton">
        @for (item of designations; track item.id) {
        <tr>
          <td>{{ item.designation_name }}</td>
          <td>{{ item.description }}</td>
          <td class="text-right icon-btns">
            <button class="btn-icon" (click)="openEditModal(item)">
              <img src="assets/images/editIcon.svg" alt="Edit" />
            </button>
            <button class="btn-icon" (click)="openDeleteModal(item)">
              <img src="assets/images/trashIcon.svg" alt="Delete" />
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Modal -->
<app-add-popup *ngIf="showAddEditModal" [title]="isEditMode ? 'Edit Designation' : 'Add New Designation'" [subtitle]="
    isEditMode
      ? 'Modify the details of this designation.'
      : 'Create a designation to organize roles and maintain a clear team structure.'
  " [iconPath]="
    isEditMode ? 'assets/images/editPopup.png' : 'assets/images/addPopup.png'
  " (close)="toggleModal('add')">
  <form [formGroup]="designationForm" (ngSubmit)="onSave()">
    <div class="input-group">
      <label>Designation Title*</label>
      <input type="text" formControlName="des_name" placeholder="Write here" />
    </div>

    <div class="input-group">
      <label>Description*</label>
      <textarea formControlName="des_description" placeholder="Write description here"></textarea>
    </div>

    <div class="input-group">
      <label>Organization*</label>
      <select formControlName="orgnazation">
        <option [ngValue]="null" disabled class="select-option">Select Organization</option>
        <option *ngFor="let org of orgDetail" [ngValue]="org">
          {{ org.name }}
        </option>
      </select>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleModal('add')">

        Cancel
      </button>
      <button type="submit" class="btn-save" [disabled]="designationForm.invalid">
        <span><img src="assets/images/savePopup.svg" alt="" /></span>
        {{ isEditMode ? "Update" : "Save" }}
      </button>
    </div>
  </form>
</app-add-popup>
<app-add-popup *ngIf="showDeleteModal" title="Delete Designation"
  subtitle="Are you sure you want to delete this designation? This action cannot be undone."
  iconPath="assets/images/deleteicon.svg" (close)="toggleModal('delete')">
  <div class="modal-footer justify-center">
    <button type="button" class="btn-cancel" (click)="toggleModal('delete')">
      Cancel
    </button>
    <button type="button" class="btn-save" (click)="confirmDelete()">
      <span> <fa-icon [icon]="faTrashCan"></fa-icon></span> Delete
    </button>
  </div>
</app-add-popup>